import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { changeDealCurrentLineData } from 'store/dealManagement/reducer';
import { getLookupData } from 'modules/api/lookups';
import withCancelRequest from 'components/hocs/withCancelRequest';

import AsyncSelect from 'lib/AsyncSelect';
import { DealStatus } from 'components/common/types/Deal.types';
import { getDealFormReadOnly } from 'store/dealManagement/selectors/getDealFormReadOnly';
import { getCurrentLineEnvironments } from 'store/dealManagement/selectors/getCurrentLineEnvironments';
import Chip, { Color, Width } from 'lib/Chip';

const Formats = ({ cancelFunctions }) => {
  const dispatch = useDispatch();
  const bookingStatusCode = useSelector((state) => state.dealManagement.commonDeal.bookingStatusCode);
  const environments = useSelector(getCurrentLineEnvironments, shallowEqual);
  const productFormats = useSelector((state) => state.dealManagement.commonDeal.currentLine.productFormats);
  const isPendingReservation = bookingStatusCode === DealStatus.PENDING_RESERVATION;
  const readOnly = useSelector(getDealFormReadOnly) && !isPendingReservation;

  const fetchProductFormat = async (dropdownName, query) => {
    try {
      const environmentCodes = environments.map((item) => item.code);
      return await getLookupData({ cancelFunctions, lookupURLName: dropdownName, query, environmentCodes });
    } catch {
      return [];
    }
  };

  return (
    <div className="space-y-4" data-test-id="formats">
      <div className="space-y-4 xl:w-4/12">
        <AsyncSelect
          dataTestId="product-format-select"
          name="productFormat"
          placeholder="Search formats"
          loadData={fetchProductFormat}
          selectedValue={productFormats}
          onSelect={(_, values) => {
            dispatch(changeDealCurrentLineData({ productFormats: values }));
          }}
          isClearable={false}
          multiple
          isMultiValueVisible={false}
          isDisabled={readOnly}
        />
      </div>
      <div data-test-id="formats-chips" className="flex flex-wrap gap-x-7 gap-y-1">
        {productFormats.length
          ? productFormats.map((product) => (
              <Chip
                key={product.code}
                label={product.name}
                onRemove={() =>
                  dispatch(
                    changeDealCurrentLineData({
                      productFormats: productFormats.filter((format) => format.code !== product.code),
                    }),
                  )
                }
                color={Color.PRIMARY}
                isDisabled={readOnly}
                dataTestId="formats-chip"
                width={Width.FULL}
                truncateLabel={false}
              />
            ))
          : null}
      </div>
    </div>
  );
};

Formats.propTypes = {
  cancelFunctions: PropTypes.objectOf(PropTypes.func).isRequired,
};

export default withCancelRequest(Formats);
